import { render, staticRenderFns } from "./LogsTabs.vue?vue&type=template&id=a275de28&scoped=true&"
import script from "./LogsTabs.vue?vue&type=script&lang=js&"
export * from "./LogsTabs.vue?vue&type=script&lang=js&"
import style0 from "./LogsTabs.vue?vue&type=style&index=0&id=a275de28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a275de28",
  null
  
)

export default component.exports